import clsx from "clsx";
import { SelectHTMLAttributes, forwardRef } from "react";

export interface SelectOption {
  value: string;
  label: string;
}

interface Props extends Omit<SelectHTMLAttributes<HTMLSelectElement>, "children"> {
  label?: string;
  options: SelectOption[];
  error?: string;
}

export const Select = forwardRef<HTMLSelectElement, Props>(function Select(
  { label, options, error, className, disabled, ...rest },
  ref,
) {
  return (
    <label className="flex flex-col gap-1 text-xs">
      {label && <span className="text-muted">{label}</span>}
      <select
        ref={ref}
        disabled={disabled}
        className={clsx(
          "bg-bg border border-line rounded px-2 py-1.5 text-sm text-text",
          "focus:outline-none focus:border-accent",
          disabled && "opacity-50 cursor-not-allowed",
          error ? "border-red-500" : "",
          className,
        )}
        {...rest}
      >
        {options.map((opt) => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>
      {error && <span className="text-red-400 text-xs">{error}</span>}
    </label>
  );
});
